import Login from "./Login";

function Landing() {
  return (
    <Login />
  );
}

export default Landing;
